import React, { SetStateAction, useState, Dispatch } from 'react';
import { IconButton, Typography, CssBaseline, Button } from "@material-ui/core";
import { makeStyles, createStyles, withStyles, WithStyles } from '@material-ui/core/styles';

import { useHistory } from "react-router-dom";

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';

import { COLORS } from './Theme'
import { SIcon } from './Icon';

import { member as v_member, basic, Values } from '../request/values';
import useFixedButtonStyles from "./commonStyles/headerEmpty/useFixedButtonStyles";

const SERVER = basic.server;


const useStyles = makeStyles((theme) => ({
    back: {
        marginLeft: '-1vh',
    },
    paper: {
        // marginTop: theme.spacing(8),
        // marginTop: '6vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    section: {
        // width : '100%',
    },
    image: {
        // width: '80%',
        textAlign: 'center',
        "& img": {
            width: '50vw',
            height: 'auto',
            // height: '30vh'
            maxWidth: '250px',
        }
        
    },
    button: {
        width: '100%',
        height: 60,
        // marginTop: '2vh',
        marginBottom: '3vh',
        borderRadius: '27px',
        boxShadow: '6px 3px 6px 0 rgba(0, 0, 0, 0.16)',
        border: 'solid 0.5px #cfd4d9',
        // backgroundColor: `${COLORS.WHITE}`,
        // color: `${COLORS.WATER_BLUE}`,
    },
    desc: {
        marginBottom: '1vh',
        fontFamily: 'NanumR',
        fontSize: 12
    },
    logoSection: {
        // position: 'absolute',
        // bottom: '5vh',
        // width: '82%',
        // textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        flex: 1,
        alignItems: 'flex-end',
        marginTop: '20vh',
    },
    title: { 
      ...theme.typography.h4,
      color: `${COLORS.BROWNISH_GREY}`, 
      fontFamily: 'NanumB', 
      margin: '2vh' 
    }
}));


const CompanyTypeSelection: React.FC<any> = props => {
    const classes = useStyles();
    const fixedButtonClasses = useFixedButtonStyles();
    const [classCode, setClassCode] = useState<string>('');
    let history = useHistory();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const { member, setMember } = props;

    const manufacturingCompany = () => {
        history.push({
            pathname: '/CompanyFoundation',
            state: {
                type: 'M'
            }
        });
    }

    const serviceCompany = () => {
        history.push({
            pathname: '/CompanyFoundation',
            state: {
                type: 'S'
            }
        });
    }

    const distributionCompany = () => {
        history.push({
            pathname: '/CompanyFoundation',
            state: {
                type: 'D'
            }
        });
    }

    const goBack = async () => {
        await setMember(
            Object.assign({}, member)
        )
        history.push({
            pathname: '/CompanyAction'
        })
    }

    return (
        <div>
                <div className={fixedButtonClasses.fixedButton}>
                <IconButton className={classes.back} onClick={() => goBack()}>
                    <SIcon type='Back' />
                </IconButton>
                </div>
                <div className={classes.paper}>
                    <div className={classes.image}>
                        <img src="/images/foundation.png" />
                    </div>
                    <Typography className={classes.title}>
                        설립할 기업의 유형을 선택하세요
                    </Typography>
                    <Button
                        fullWidth
                        className={classes.button}
                        onClick={manufacturingCompany}
                    >
                        <Typography variant="h3" style={{ color: `${COLORS.WATER_BLUE}`, fontFamily: 'NanumB'}}>
                            제조기업
                        </Typography>
                    </Button>
                    <Button
                        fullWidth
                        className={classes.button}
                        onClick={distributionCompany}
                    >
                        <Typography variant="h3" style={{ color: `${COLORS.WATER_BLUE}`, fontFamily: 'NanumB' }}>
                            유통기업
                        </Typography>
                    </Button>
                </div>
                <div className={classes.logoSection}>
                    <SIcon type="P" />
                </div>
        </div>


    );
}

export default CompanyTypeSelection;